import { mapAlgoliaPage } from '../../../shared/domain/mappers/map-algolia-page.ts'
import type { Paged } from '../../../shared/domain/models/paged.ts'
import type { VoiceFilters } from '../models/voice-filters.ts'
import type { VoiceParameters } from '../models/voice-parameters.ts'
import type { Voice } from '../models/voice.ts'
import { mapVoiceFacetsToVoiceFilters } from '../mappers/map-voice-facets-to-voice-filters.ts'
import { mapVoiceDtoToVoice } from '../mappers/map-voice-dto-to-voice.ts'
import { VoiceService } from '../../data/voice.service.ts'

export const fetchVoices = async (
  page: number,
  filters: VoiceFilters,
  searchTerm?: string
): Promise<Paged<Voice, VoiceParameters>> => {
  const PAGE_SIZE = 20
  const res = await VoiceService.getVoices(page, PAGE_SIZE, searchTerm, filters)
  return mapAlgoliaPage(mapVoiceDtoToVoice, mapVoiceFacetsToVoiceFilters, res)
}
